module.exports = __webpack_public_path__ + "static/media/kefuNew.7e775612.png";